var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"audit-actions"},[_c('el-button',{attrs:{"size":"mini","type":"success","plain":""},on:{"click":function($event){return _vm.$emit('audit', 'approved')}}},[_vm._v("审核通过")]),_c('el-button',{attrs:{"size":"mini","type":"warning","plain":""},on:{"click":function($event){return _vm.$emit('audit', 'hidden')}}},[_vm._v("隐藏")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }